/**
 * NPS tab — extracted retirement accounts.
 * Uploads live on the dedicated Upload Documents tab.
 */
import { Card, CardContent, Skeleton } from '@finmin/ui';
import { PiggyBank } from 'lucide-react';
import { useExtractedProfile } from '@/api/profile-documents';
import { NpsAccountCard } from '@/features/nps/nps-account-card';

export function NpsTab() {
  const { data, isLoading } = useExtractedProfile();
  const accounts = data?.nps_accounts ?? [];

  // A customer has a single NPS/PRAN, so re-uploading a statement produces a
  // fresh extraction of the same account. Show only the most recently
  // extracted record rather than every historical extraction.
  const latest =
    accounts.length > 0
      ? [...accounts].sort(
          (a, b) =>
            new Date(b.extracted_at).getTime() -
            new Date(a.extracted_at).getTime(),
        )[0]
      : null;

  if (isLoading) {
    return <Skeleton className="h-64 w-full rounded-xl" />;
  }
  if (!latest) {
    return <EmptyState />;
  }
  return (
    <div className="space-y-5">
      <NpsAccountCard account={latest} />
    </div>
  );
}

function EmptyState() {
  return (
    <Card>
      <CardContent className="py-10 text-center">
        <PiggyBank
          className="mx-auto h-10 w-10 text-muted-foreground/60"
          aria-hidden
        />
        <p className="mt-3 text-sm font-medium text-foreground">
          No NPS account yet
        </p>
        <p className="mt-1 text-xs text-muted-foreground">
          Head to the <span className="font-medium text-foreground">Upload Documents</span>{' '}
          tab to add your NPS statement. We'll surface your corpus, allocation,
          XIRR, and tax benefits here.
        </p>
      </CardContent>
    </Card>
  );
}
